import React, { useState } from 'react';
import { addCall } from '../../api';

function AddCallDialog({ customerId, userId, onSave, onCancel }) {
  const [status, setStatus] = useState('');
  const [kommentar, setKommentar] = useState('');
  const [ruckrufZeit, setRuckrufZeit] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Prüfen ob Rückruf erwünscht ausgewählt ist
  const showRuckrufZeit = status === 'Rückruf erwünscht';

  const getMinDateTime = () => {
    const now = new Date();
    now.setHours(now.getHours() + 1);
    return now.toISOString().slice(0, 16); // Format: YYYY-MM-DDTHH:mm
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    // Validierung für Rückruf erwünscht
    if (status === 'Rückruf erwünscht' && !ruckrufZeit) {
      setError('Bitte wählen Sie eine Rückruf-Zeit aus');
      setLoading(false);
      return;
    }
    
    try {
      const data = await addCall(userId, customerId, status, kommentar, ruckrufZeit);
      
      if (data.success) {
        onSave(data.call);
      } else {
        setError(data.error || 'Fehler beim Hinzufügen des Anrufs');
      }
    } catch (err) {
      setError('Netzwerkfehler: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleStatusChange = (newStatus) => {
    setStatus(newStatus);
    // Rückruf-Zeit zurücksetzen wenn anderer Status gewählt wird
    if (newStatus !== 'Rückruf erwünscht') {
      setRuckrufZeit('');
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-dialog">
        <h3>Neuen Anruf hinzufügen</h3>
        {error && <div className="error-message">{error}</div>}
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Status</label>
            <select
              value={status}
              onChange={(e) => handleStatusChange(e.target.value)}
              required
            >
              <option value="">-- Status wählen --</option>
              <option value="Erfolgreich">Erfolgreich</option>
              <option value="Nicht erreicht">Nicht erreicht</option>
              <option value="Rückruf erwünscht">Rückruf erwünscht</option>
            </select>
          </div>

          {/* Rückruf-Zeit Auswahl - nur anzeigen wenn "Rückruf erwünscht" */}
          {showRuckrufZeit && (
            <div className="form-group ruckruf-zeit-group">
              <label>Gewünschte Rückruf-Zeit</label>
              <input
                type="datetime-local"
                value={ruckrufZeit}
                onChange={(e) => setRuckrufZeit(e.target.value)}
                min={getMinDateTime()}
                required={showRuckrufZeit}
                className="ruckruf-zeit-input"
              />
            </div>
          )}
          
          <div className="form-group">
            <label>Kommentar</label>
            <textarea
              value={kommentar}
              onChange={(e) => setKommentar(e.target.value)}
              rows={4}
              placeholder="Kommentar zum Anruf..."
            ></textarea>
          </div>
          
          <div className="modal-actions">
            <button type="button" onClick={onCancel} className="cancel-button">
              Abbrechen
            </button>
            <button 
              type="submit" 
              disabled={loading || !status || (showRuckrufZeit && !ruckrufZeit)}
            >
              {loading ? 'Wird gespeichert...' : 'Anruf speichern'}
            </button>
          </div>
        </form>
      </div>

      <style jsx>{`
        .ruckruf-zeit-group {
          background-color: #f7fafc;
          border: 1px solid #e2e8f0;
          border-radius: 8px;
          padding: 16px;
          margin: 16px 0;
          transition: all 0.3s ease;
        }

        .ruckruf-zeit-input {
          width: 100%;
          padding: 10px;
          border: 1px solid #d1d5db;
          border-radius: 6px;
          font-size: 14px;
          background-color: white;
        }

        .ruckruf-zeit-input:focus {
          outline: none;
          border-color: #4a6de5;
          box-shadow: 0 0 0 3px rgba(74, 109, 229, 0.1);
        }

        .helper-text {
          font-size: 12px;
          color: #6b7280;
          margin-top: 4px;
          font-style: italic;
        }

        .ruckruf-zeit-group label {
          color: #2d3748;
          font-weight: 600;
          margin-bottom: 8px;
          display: block;
        }
      `}</style>
    </div>
  );
}

export default AddCallDialog;